export interface Experience {
    title: string;
    image: string;       // add URL or path later
    price: number | null;
    description: string;
}

export const experiences: Experience[] = [
    {
        title: "Single Car Crush",
        price: 649,
        image: "/img/addons/CarCrush2.jpg",
        description:
            "Get behind the driver’s seat of the 120,000 lb Chieftain Main Battle Tank and drive it straight over a car! Adding this to your package makes for a full tank experience. Ask about adding one to your tank package!"
    },
    {
        title: "Double Car Crush",
        price: 849,
        image: "/img/addons/DoubleCrush.jpg",
        description:
            "If you’re a go‑big‑or‑go‑home kinda person, this is for you. Experience the ultimate adrenaline rush as the 120,000 lb tank climbs over two vehicles and comes crashing down."
    }
];
